import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { useTweaks } from '../context/TweaksContext';

/**
 * Tweaks panel — designer/PM dev tool (SPEC §16). Controls Appearance
 * (mode / navigation / density), Theme palette, and Quick-jump navigation.
 * Hidden behind a floating button; not a customer-facing feature.
 */
const SWATCH_BG = {
  warm:  'oklch(0.36 0.080 155)',
  slate: 'oklch(0.32 0.060 250)',
  ink:   'oklch(0.22 0.012 30)',
};

const QUICK_JUMP = [
  ['Dashboard', '/admin'],
  ['Bookings', '/admin/bookings'],
  ['New booking', '/admin/bookings/new'],
  ['New rental', '/admin/bookings/rentals/new'],
  ['Refunds', '/admin/refunds'],
  ['Calendar', '/admin/calendar'],
  ['Facilities', '/admin/facilities'],
  ['Users', '/admin/users'],
];

function Seg({ options, value, onChange }) {
  return (
    <div className="sb-chipset" style={{ width: '100%', display: 'flex' }}>
      {options.map(o => (
        <div key={o} className={`sb-chip ${value === o ? 'active' : ''}`}
             style={{ flex: 1, textAlign: 'center', textTransform: 'capitalize' }}
             onClick={() => onChange(o)}>
          {o}
        </div>
      ))}
    </div>
  );
}

export default function AdminTweaks() {
  const [open, setOpen] = useState(false);
  const { theme, toggle } = useTheme();
  const { palette, setPalette, density, setDensity, nav, setNav, PALETTES, DENSITIES, NAV_MODES } = useTweaks();
  const navigate = useNavigate();
  const isDark = theme === 'dark';

  return (
    <>
      <button className="sb-tweaks-fab" onClick={() => setOpen(o => !o)} title="Tweaks" aria-label="Open tweaks panel">
        <svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round">
          <circle cx="10" cy="10" r="2.6" />
          <path d="M10 2v2.4M10 15.6V18M2 10h2.4M15.6 10H18M4.3 4.3l1.7 1.7M14 14l1.7 1.7M15.7 4.3L14 6M6 14l-1.7 1.7" />
        </svg>
      </button>

      {open && (
        <div className="sb-tweaks-panel" role="dialog" aria-label="Tweaks">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <strong style={{ fontSize: 13 }}>Tweaks</strong>
            <button className="sb-btn ghost sm" onClick={() => setOpen(false)}>Close</button>
          </div>

          <div className="sb-tweaks-sec">Appearance</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Seg options={['light', 'dark']} value={isDark ? 'dark' : 'light'}
                 onChange={(m) => { if ((m === 'dark') !== isDark) toggle(); }} />
            <Seg options={NAV_MODES} value={nav} onChange={setNav} />
            <Seg options={DENSITIES} value={density} onChange={setDensity} />
          </div>

          <div className="sb-tweaks-sec">Theme</div>
          <div className="sb-swatch-row">
            {PALETTES.map(p => (
              <div key={p} className={`sb-swatch ${palette === p ? 'active' : ''}`}
                   style={{ background: SWATCH_BG[p] }} onClick={() => setPalette(p)}>
                {p}
              </div>
            ))}
          </div>

          <div className="sb-tweaks-sec">Quick jump</div>
          <div className="sb-quickjump">
            {QUICK_JUMP.map(([label, to]) => (
              <button key={to} className="sb-btn sm" style={{ justifyContent: 'center' }}
                      onClick={() => { navigate(to); setOpen(false); }}>
                {label}
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
